import { render, staticRenderFns } from "./companion.vue?vue&type=template&id=753df6b0&scoped=true"
import script from "./companion.vue?vue&type=script&lang=ts"
export * from "./companion.vue?vue&type=script&lang=ts"
import style0 from "./companion.vue?vue&type=style&index=0&id=753df6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753df6b0",
  null
  
)

export default component.exports